export const abTestStorageKey = 'cvly-app-exp';

export const experienceKeys = {
  Control: 'control',
  Variant: 'variant',
};

export const abTests = {
  active: true,
  name: 'lead-screen-headline',
  segments: [
    {
      name: 'Control',
      weight: 0.5,
      value: experienceKeys.Control,
    },
    {
      name: 'Experiment',
      weight: 0.5,
      value: experienceKeys.Variant,
    },
  ],
  permitted: [
    /^(?:\/)$/,
  ],
};
